<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container
    [fluid]="true"
    class="px-4"
    style="display: flex; justify-content: space-between; align-items: center"
  >
    <div class="d-flex flex-row align-items-center justify-content-start">
      <button
        [cSidebarToggle]="sidebarId"
        cHeaderToggler
        class="btn d-lg-none pe-3 me-3"
        toggle="visible"
        style="margin-inline-start: -14px"
      >
        <svg cIcon name="cilMenu" size="lg"></svg>
      </button>
      <ng-container *ngIf="!isUserAdministrator(); else emptyContent">
        <c-row
          style="
            /* flex-basis: 20%; */
            background-color: #56dbc2;
            border-radius: 10em;
            padding: 5px;
            color: white;
            text-align: center;
          "
        >
          <c-col>
            <svg cIcon name="cilStar" size="lg"></svg>
            <b style="font-weight: bolder; font-size: large"> {{points}}</b>
            <span style="font-weight: lighter; margin-left: 5px">
              Puntos <span class="d-none d-md-inline">Acumulados</span>
            </span>
          </c-col>
        </c-row>
      </ng-container>
      <ng-template #emptyContent>
        <c-row><c-col></c-col></c-row>
      </ng-template>

    </div>


    <c-row>
      <c-col>
        <c-header-nav class="ms-auto ms-md-0">
          <div class="nav-item py-1">
            <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
          </div>
          <ng-container *ngTemplateOutlet="themeDropdown" />
          <div class="nav-item py-1">
            <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
          </div>
        </c-header-nav>
      </c-col>
      <c-col>
        <c-header-nav class="ms-0">
          <ng-container *ngTemplateOutlet="userDropdown" />
        </c-header-nav>
      </c-col>
    </c-row>
  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown
    [popperOptions]="{ placement: 'bottom-start' }"
    variant="nav-item"
  >
    <button [caret]="false" cDropdownToggle class="py-0">
      <c-avatar
        size="md"
        [src]="photo"
        status="success"
        textColor="primary"
      />
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <h6
          cDropdownHeader
          class="bg-body-secondary text-body-secondary fw-semibold py-2 rounded-top"
        >
          {{ name }}
        </h6>
      </li>

      <li>
        <a cDropdownItem (click)="onUserProfile()" style="cursor: pointer;">
          <svg cIcon class="me-1" name="cilUser"></svg>
          Perfil de usuario
        </a>
      </li>

      <li>
        <a cDropdownItem (click)="logout()" style="cursor: pointer;">
          <svg cIcon class="me-1" name="cilAccountLogout"></svg>
          Cerrar Sesión
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle>
      @switch (colorMode()) { @case ("dark") {
      <svg cIcon name="cilMoon" size="lg"></svg>
      } @case ("auto") {
      <svg cIcon name="cilContrast" size="lg"></svg>
      } @default {
      <svg cIcon name="cilSun" size="lg"></svg>
      } }
    </button>
    <div cDropdownMenu>
      <button
        (click)="colorMode.set('light')"
        [active]="colorMode() === 'light'"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" name="cilSun" size="lg"></svg>
        Light
      </button>
      <button
        (click)="colorMode.set('dark')"
        [active]="colorMode() === 'dark'"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" name="cilMoon" size="lg"></svg>
        Dark
      </button>
      <button
        (click)="colorMode.set('auto')"
        [active]="colorMode() === 'auto'"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" name="cilContrast" size="lg"></svg>
        Auto
      </button>
    </div>
  </c-dropdown>
</ng-template>
